/**
 * Loading Spinner Component
 * Displays loading state
 */

import { cn } from '@/utils/classNames';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface LoadingSpinnerProps {
  size?: SpinnerSize;
  className?: string;
  label?: string;
}

const sizeStyles: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-3',
  lg: 'h-12 w-12 border-4',
};

export function LoadingSpinner({
  size = 'md',
  className,
  label = 'Loading...',
}: LoadingSpinnerProps) {
  return (
    <div
      className={cn('flex items-center justify-center gap-3', className)}
      role="status"
      aria-label={label}
    >
      <div
        className={cn(
          'animate-spin rounded-full',
          'border-stellar-primary border-t-transparent',
          sizeStyles[size]
        )}
      />
      {label && <span className="text-sm text-text-secondary">{label}</span>}
    </div>
  );
}
